module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ab05b9e5f400a1e4ad1.worker.js");
};